import React from 'react';
import { useHistory } from 'react-router-dom';
import ReactGA from 'react-ga4';

import { Button, Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles( (mainTheme) => ({
  buttonStyle: {
    [mainTheme.breakpoints.down('sm')]: {
      fontSize: "8px"
    },
  },
})) 

export default function ButtonSignUp (){
  const classes = useStyles();
  const history = useHistory();

  const handleRegister=()=>{
    ReactGA.event({
      category: "ButtonSignUp",
      action: "onclick",

    });
    history.push('/pricing')
  }

  return(
    <>
    <Tooltip title="Sign up and register to get access to valuations and users profiles">
      <Button 
        variant = "contained" 
        // startIcon = {<AppRegistrationIcon />} 
        autoFocus
        disableRipple
        onClick = { handleRegister } 
        // disabled = {userId? false : true}
        className = {classes.buttonStyle}
        >Sign up NOW, get full access !
      </Button>
    </Tooltip>
    </>
  )
}